import { render, staticRenderFns } from "./CaseAdBayer.vue?vue&type=template&id=67b08a48&lang=pug"
import script from "./CaseAdBayer.vue?vue&type=script&lang=js"
export * from "./CaseAdBayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports